let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '更改能量数/g',
        props: 'energyVal',
        minWidth: 250,
    },
    {
        label: '更改类型',
        props: 'setModelName',
        minWidth: 200,
    },
    {
        label: '更改前能量数/g',
        props: 'energyValBef',
        minWidth: 150,
    },
    {
        label: '更改后能量数/g',
        props: 'energyValAft',
        minWidth: 200,
    },
    {
        label: '备注',
        props: 'remark',
        minWidth: 200,
    },
    {
        label: '更改操作人',
        props: 'lastModifiedByName',
        minWidth: 200,
    },
    {
        label: '更改时间',
        props: 'lastModifiedWhen',
        minWidth: 200,
    },
];


// 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '蚂蚁能量',
    },
    {
        type: 'title',
        name: '获取记录'
    },
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

// 列表-详情操作
// pageConfig.tableDetailObj = {
//     editKey: 'id',
//     editRouter: 'pileDetailTab',
// };

// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileDetail',
};

// 路由
pageConfig.listRouter = 'pileList';


// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '订单管理',
    },
    {
        type: 'title',
        name: '私桩充电订单',
    },
    {
        type: 'router',
        name: '正常订单',
        router: 'normalList'
    },
    {
        type: 'title',
        name: '充电桩详情'
    }
];
// 详情的面包屑
pageConfig.unusualDetailBreadCrumb = [
    {
        type: 'title',
        name: '订单管理',
    },
    {
        type: 'title',
        name: '私桩充电订单',
    },
    {
        type: 'router',
        name: '异常订单',
        router: 'unusualList'
    },
    {
        type: 'title',
        name: '充电桩详情'
    }
];

pageConfig.formRules = {
    pileCode: [{ required: true, message: '请输入IMEI号', trigger: 'blur' }],
    pileTypeNo: [{ required: true, message: '请选择充电桩型号名称', trigger: 'change' }],
    currentOutType: [{ required: true, message: '请选择电流输出类型', trigger: 'change' }],
    gunNum: [{ required: true, message: '请输入充电桩枪数', trigger: 'blur' }],
    //dealName: [{ required: true, message: '请选择经销商名称', trigger: 'change' }],
    optType: [{ required: true, message: '请选择充电桩类型', trigger: 'change' }],
    chargingSpeed: [{ required: true, message: '请选择充电速度', trigger: 'change' }],
    interfaceType: [{ required: true, message: '请选择接口标准', trigger: 'change' }],
    applyReason: [{ required: true, message: '请填写申请原因', trigger: 'blur' }],
    repairPerson: [{ required: true, message: '请填写维修人', trigger: 'blur' }],
    repairStatus: [{ required: true, message: '请选择维修状态', trigger: 'change' }],
    repairResult: [{ required: true, message: '请选择维修结果', trigger: 'change' }],
    repairDateNum: [{ required: true, message: '请填写维修时间', trigger: 'blur' }],
    corpReturn: [{ required: true, message: '请填写运营商回执', trigger: 'blur' }],
};



export default pageConfig;
